import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function GoaStandard() {
    const heading = "Standard Room";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Goa Room</span> {heading}
                    </>
                ),
        breadcrumb: [
        {
            slug: "/resort-de-coracao-goa/room-listing",
            name: (
                    <>
                    <span className="sr-only">{heading}</span> Rooms
                    </>
                ),
        },
        {
            slug: "",
            name: "Standard Room",
        },
        ]
    }

    const roomBanner = {
        image: "/image/goa-standard-room-detail.webp",
    };

    const roomQuote = {
        content: "If you’re the kind of traveler who spends the day exploring Goa’s sun-drenched streets & needs a quiet, cool place to recharge, this is it. It’s simple, smart, & incredibly welcoming. You get a plush king bed to sink into after a long day at the beach, with comfort & just enough space to feel tucked away from the world.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "King",
        area: "21",
        bathroom: "1",
        guest: "2",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/goa-standard-room-gallery-1.webp"},
        { image: "/image/goa-standard-room-gallery-2.webp"},
        { image: "/image/goa-standard-room-gallery-3.webp"},
        { image: "/image/goa-standard-room-gallery-4.webp"},
        { image: "/image/goa-standard-room-gallery-5.webp"},
        { image: "/image/goa-standard-room-gallery-6.webp"}
    ];

    const roomEquipment = {
        description: "Enjoy a welcoming accommodation experience with comfortable spaces and modern amenities suited to both relaxation and convenience.",
        equipment: [
        [
            "Walk-in Shower & Hair Dryer",
            "Coffee & Tea Maker for your morning fix",
            "High-speed Wi-Fi to share your holiday photos",
            "Personal In-Room Safe for your valuables",
        ],
        [
            "42-inch LED TV with DTH for movie nights",
            "Writing Desk for those quic work-from-anywhere moments",
            "Daily Housekeeping to keep things fresh",
            "Mini-Refrigerator to keep your drinks chilled",
        ],
        [
            "Soft 100% Cotton Linens & Duvet",
            "24-Hour Room Service for late-night cravings",
            "Iron & Ironing Board (available on request)",
            "Hot Keys with Speaker Phone",
            "Dual Voltage Adaptors for easy charging",
        ]
    ]
    };

    const roomBook = {
        location: "Goa",
        title: "Standard Room",
        desc: "Enjoy a comfortable stay at De Coracao Goa’s Standard Room, thoughtfully designed for relaxed getaways. With a plush king bed, modern amenities, and a welcoming ambience, it gives you the perfect space to unwind and recharge after a day of exploring Goa.",
        details: [
            "1 King Size Bed",
            "2 Guests",
            "21 sq. mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Premium Room',
                bg: '/image/goa-other-room-1.webp',
                slug: '/resort-de-coracao-goa/premium-room',
                details: [
                "1 King Bed + 1 Extra Mattress ",
                "Up to 3 Guests",
                "Quite spacious",
                ],
            },
            
            {
                title: 'Super Deluxe Room',
                bg: '/image/goa-other-room-2.webp',
                slug: '/resort-de-coracao-goa/super-deluxe-room',
                details: [
                "1 King Size Bed + 1 Extra Mattress ",
                "Up to 3 Guests",
                "28 sq mt",
                ],
            },
            
            {
                title: 'Suite Room',
                bg: '/image/goa-other-room-3.webp',
                slug: '/resort-de-coracao-goa/suite-room',
                details: [
                "1 King Size Bed + Living Room Seating",
                "3 Guests",
                "37 sq.mt.",
                ],
            },
            
            {
                title: 'Deluxe Room',
                bg: '/image/goa-other-room-4.webp',
                slug: '/resort-de-coracao-goa/deluxe-room',
                details: [
                "1 King Size Bed",
                "2 Guests",
                "24 sq mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-goa/room-listing"}
    }

  return (
    <>  
        <Subheader subheadData={subheadData} />
        <RoomBanner roomBanner={roomBanner}/>
        <RoomQuote roomQuote={roomQuote}/>
        <RoomCount roomCount={roomCount}/>
        <RoomGallery roomGallery={roomGallery}/>
        <RoomEquipment roomEquipment={roomEquipment}/>
        <RoomBook roomBook={roomBook}/>
        <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
    </>
  )
}
